import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ModalVariants } from '../../models/Common';
import { SharePromo3Month } from '../../components/servicePaymentParts/SharePromoBRIZTVPremium';
import { Image } from '../../models/ServicePresets';
import { OrderParams, PreparedCalculateData } from '../../models/Calculate';

export interface ModalContent {
  title?: string;
  description?: string;
  boldDescription?: string;
  phone?: string;
  phoneId?: number;
  method?: 'PATCH' | 'DELETE';
  login?: string;
  amount?: number;
  accountId?: number | string;
  macAddress?: string;
  deviceId?: number;
  cardNumber?: string;
  cardId?: string;
  comment?: string;
  service?: string;
  accountType?: string;
  isGigabitPromo?: boolean;
  isActiveCard?: boolean;
  serviceAnalyticsName?: string;
  connectionProtocolId?: number;
  selectedLanguage?: string;
  search?: string;
  userId?: number;
  isShare?: boolean;
  shareCalculation?: SharePromo3Month;
  handlePay?: () => void;
  handleProceed?: (arg?: unknown) => void;
  handleActivate?: () => void;
  customShareName?: string;
  buttonShareName?: string;
  images?: Image;
  currentCalculation?: PreparedCalculateData | null;
  paramsForCalculation?: OrderParams;
  email?: string;
  notice?: string;
  isDaily?: boolean;
}

interface ModalState {
  isOpen: boolean;
  variant: ModalVariants;
  content?: ModalContent | null;
}

const initialState: ModalState = {
  isOpen: false,
  variant: ModalVariants.PayMethods,
  content: null,
};

export const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    openModal(state, { payload }: PayloadAction<{ modalVariants: ModalVariants; content?: ModalContent }>) {
      state.isOpen = true;
      state.variant = payload.modalVariants;
      state.content = payload.content || null;
      window.scrollTo(0, 0);
    },
    closeModal(state) {
      state.isOpen = false;
    },
  },
});

export default modalSlice.reducer;
